<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='wms wms-instock' class='navbarbtn' v-if='showICMOInStockPower'
        @click='showICMOInStockDialogMD'>
        生产入库
      </el-button>

      <el-button type='danger' icon='wms wms-instock' class='navbarbtn' v-if='showICMOOutStockPower'
        @click='showICMOOutStockDialogMD'>
        产品退库
      </el-button>

      <el-button type='warning' icon='sys sys-clear' class='navbarbtn' v-if='showFINotPower'
        @click='fiNotSet'>
        入库先进先出忽略
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.sourceBillNo' style='width: 125px;' placeholder='生产任务单号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='130px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :reduceHeight='200' :seqFixed='true'
      :expandRowKeys='mainTable.expandRowKeys'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <div v-if='scope.data.row.FROB === "1"'>
          <el-tooltip effect='dark' content='重新上传' placement='top-start' v-if='showReUploadICMOInStockPower'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='uploadICMOICStockBill(scope)'><i class='sys sys-uploaddocument'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletedICMOInStockPower'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deletedICMOICStockBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='单据明细' placement='top-start'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='showICStockBillEntryDialogMD(scope)'><i class='sys sys-record'></i>
            </el-button>
          </el-tooltip>
        </div>
        <div v-if='scope.data.row.FROB === "-1"'>
          <el-tooltip effect='dark' content='重新上传' placement='top-start' v-if='showReUploadICMOOutStockPower'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='uploadICMOOutICStockBill(scope)'><i class='sys sys-uploaddocument'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletedICMOOutStockPower'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deletedICMOOutICStockBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='单据明细' placement='top-start'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='showICStockBillEntryDialogMD(scope)'><i class='sys sys-record'></i>
            </el-button>
          </el-tooltip>
        </div>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 150px; text-align: left;'><span style='color: #42426F;'>仓库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>仓位代码</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>生成/采购日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>源单单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>生产任务单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='wibe in scope.data.row.detailDt1'
            :key='wibe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{wibe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{wibe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{wibe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{wibe.Qty}}{{wibe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 150px; text-align: left;'><span style='color: blue;'>{{wibe.DCStockName}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'><span style='color: blue;'>{{wibe.DCSPNumber}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: blue;'>{{wibe.BatchNo}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'>
              <span style='color: blue;'>
                {{!wibe.KFDate ? '' : dateTimeUtil.formartDateTime(new Date(wibe.KFDate), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 80px; text-align: left;'><span style='color: blue;'>{{wibe.KFPeriod}} </span></div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: blue;'>{{wibe.MESSourceBillNo}} </span></div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: blue;'>{{wibe.SourceBillNo}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{wibe.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog title='生产入库' :visible.sync='showICMOInStockDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='sourceTranType' placeholder='请选择'
          class='inputField-input' :disabled='sourceInterID.length > 0'
          @change='sourceTranTypeChange' :clearable='false'
          style='width: 200px;' size='mini'>
          <el-option v-for='sourceTranType in mainTable.sourceTranTypes'
            :key='sourceTranType.code' :label='sourceTranType.name' :value='sourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单单号
        </div>
        <TableSelect v-model='sourceInterID' key='PM_ICMO' v-if='sourceTranType === "85"'
          class='inputField-input' ref='icmoSelectTable'
          :displayValue='""' :disabled='scanQRCodes.length > 0'
          returnCode='InterID' displayCode='BillNo'
          customFilterStr=" AND Status IN ('1','2')"
          style='width: 200px;' tableCode='PM_ICMO'></TableSelect>
        <TableSelect v-model='sourceInterID' key='PM_ICMOInRequest' v-if='sourceTranType === "WMS12"'
          class='inputField-input' ref='icmoInRequestSelectTable'
          :displayValue='""' :disabled='scanQRCodes.length > 0'
          returnCode='ICMOInRequestNo' displayCode='ICMOInRequestNo'
          customFilterStr=" AND Status IN ('1','2')"
          @change='sourceInterIDChange'
          style='width: 200px;' tableCode='PM_ICMOInRequest'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='scanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          收料仓库
        </div>
        <el-select v-model='icstockBillInfo.DCStockID' placeholder='请选择'
          class='inputField-input' @change='dcstockChange'
          style='width: 200px;' size='mini'>
          <el-option v-for='stock in stocks'
            :key='stock.StockID' :label='stock.Name' :value='stock.StockID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          收料仓位
        </div>
        <TableSelect v-model='icstockBillInfo.DCSPID' ref='icstockBillInfoDCSPIDTableSelect'
          class='inputField-input'
          :displayValue='""' :customFilterStr="' AND SPGroupID=\'' + dcstockTeam + '\''"
          returnCode='SPID' displayCode='Name'
          style='width: 200px;' tableCode='BD_StockPlace'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          验收人
        </div>
        <TableSelect v-model='icstockBillInfo.FManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          摘  要
        </div>
        <el-input v-model='icstockBillInfo.Explanation' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          保管人
        </div>
        <TableSelect v-model='icstockBillInfo.SManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <el-tabs v-model='activeTable'
        type='card' style='background: #fff; height: 100%; margin-top: 120px;'>
        <el-tab-pane label='产品入库申请单' name='icmoIR'>
          <el-table :data='sourceEntrys' border :height='getScanQRCodesTableHeight()'
            ref='sourceEntrysTable' style='margin-top: 0px;'
            :highlight-current-row='false'
            :cell-style='sourceEntrysTableCellStyle' row-key='GUID'
            :header-cell-style='mainTableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='EntryID' label='行号' width='60'>
            </el-table-column>
            <el-table-column prop='ItemNumber' label='物料代码' width='250'>
            </el-table-column>
            <el-table-column prop='ItemName' label='物料名称' width='200'>
            </el-table-column>
            <el-table-column prop='ItemModel' label='规格' width='200'>
            </el-table-column>
            <el-table-column prop='Qty' label='计划数量' width='100' align='right'>
            </el-table-column>
            <el-table-column prop='StockQty' label='已入库数量' width='100' align='right'>
            </el-table-column>
            <el-table-column prop='CanInQty' label='本次可入数量' width='120' align='right'>
            </el-table-column>
            <el-table-column prop='UnitName' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='ScanQty' label='已扫码数量' width='120' align='right'>
            </el-table-column>
            <el-table-column prop='ScanPackageQty' label='已扫码包数' width='120' align='right'>
            </el-table-column>
            <el-table-column prop='StockName' label='指定仓库' width='200'>
            </el-table-column>
            <el-table-column prop='ICMOBillNo' label='生产任务单号' width='200'>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label='已扫标签' name='qrCode'>
          <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
            ref='scanQRCodesTable' style='margin-top: 0px;'
            :cell-style='mainTableCellStyle' row-key='GUID'
            :header-cell-style='mainTableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='QRCode' label='标签号' width='200'>
            </el-table-column>
            <el-table-column prop='BI_Number' label='物料代码' width='300'>
            </el-table-column>
            <el-table-column prop='BI_Name' label='物料名称' width='350'>
            </el-table-column>
            <el-table-column prop='BI_Model' label='规格' width='200'>
            </el-table-column>
            <el-table-column prop='Qty' label='数量' width='60'>
            </el-table-column>
            <el-table-column prop='BU_Name' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
            <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
            </el-table-column>
            <el-table-column prop='Status' label='状态' width='60'>
              <template #default='scope'>
                {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
              </template>
            </el-table-column>
            <el-table-column label='操作' width='60' fixed='right'>
              <template #default='scope'>
                <el-button type='danger' circle style='padding: 4px;'
                  @click='deleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoInStock()' size='mini'>入库</el-button>
        <el-button @click='showICMOInStockDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title='生产退库' :visible.sync='showICMOOutStockDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='outSourceTranType' placeholder='请选择'
          class='inputField-input' disabled
          :clearable='false'
          style='width: 200px;' size='mini'>
          <el-option v-for='sourceTranType in mainTable.sourceTranTypes'
            :key='sourceTranType.code' :label='sourceTranType.name' :value='sourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          验收人
        </div>
        <TableSelect v-model='outICStockBillInfo.FManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          保管人
        </div>
        <TableSelect v-model='outICStockBillInfo.SManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <div style='margin-top: 10px;'>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          摘  要
        </div>
        <el-input v-model='outICStockBillInfo.Explanation' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='outScanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <el-table :data='scanQRCodes' border :height='getOutScanQRCodesTableHeight()'
        ref='outScanQRCodesTable' style='margin-top: 80px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='QRCode' label='标签号' width='200'>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='BU_Name' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='ICMOBillNo' label='工单号' width='200'>
        </el-table-column>
        <el-table-column prop='Status' label='状态' width='60'>
          <template #default='scope'>
            {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
          </template>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='outDeleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoOutStock()' size='mini'>退库</el-button>
        <el-button @click='showICMOInStockDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='产品入库单明细' :visible.sync='showICStockBillEntryDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='icStockBillEntry' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;' default-expand-all>
        <el-table-column type='expand' width='50'>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
              </div>
            </div>
            <div class='expand'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.detailDt1'
                :key='qrCode.QRCode' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'></span>{{qrCodeIndex + 1}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.QRCode}} </div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'></span>{{qrCode.Qty}}{{qrCode.BU_Name}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.OuterQRCode}} </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='300'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格型号' width='250'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='80'>
        </el-table-column>
        <el-table-column prop='DCStockName' label='仓库' width='160'>
        </el-table-column>
        <el-table-column prop='DCSPNumber' label='仓位代码' width='120'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import TableSelect from '@/components/custom/TableSelect.vue'
import ExportExcel from '@/components/export/ExportExcel.vue'
import code from '@/components/sys/Code'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'ICMOInStock',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel,
    TableSelect: TableSelect
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_ICStockBill_PM',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',
        sourceBillNo: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: [],

        sourceTranTypes: []
      },

      dateTimeUtil: dateTimeUtil,

      showICMOInStockDialog: false,
      sourceTranType: 'WMS12',
      sourceInterID: '',
      sourceEntrys: [],
      activeTable: 'qrCode',
      scanQRCode: '',
      scanQRCodes: [],
      qrcodeStatuss: [],
      stocks: [],
      dcstockTeam: '',
      icstockBillInfo: {
        DCStockID: '',
        DCSPID: '',
        FManagerID: '',
        SManagerID: '',
        Explanation: '',
        Remark: '',
        DeptID: ''
      },

      showICMOOutStockDialog: false,
      outSourceTranType: '85',
      outSourceInterID: '',
      outICStockBillInfo: {
        FManagerID: '',
        SManagerID: '',
        Explanation: '',
        Remark: ''
      },

      showICStockBillEntryDialog: false,
      icStockBillEntry: [],
      icStockBill: {},

      showICMOInStockPower: false,
      showReUploadICMOInStockPower: false,
      showDeletedICMOInStockPower: false,
      showICMOOutStockPower: false,
      showReUploadICMOOutStockPower: false,
      showDeletedICMOOutStockPower: false,
      showFINotPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)

    const codes = that.codes
    that.mainTable.sourceTranTypes = code.getCode(codes, 'WMS_TranType', ['85', 'WMS12'])
    that.qrcodeStatuss = code.getCode(codes, 'WMS_QRCode_Status')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const stockObjPromise = table.getTableContent('BD_Stock', 10000, 1, '', " AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const stockObj = await stockObjPromise
    that.stocks = stockObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.sourceBillNo) {
        const sourceBillNos = that.mainTable.sourceBillNo.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < sourceBillNos.length; i++) {
          detail1FilterStr += " OR SourceBillNo LIKE'%" + sourceBillNos[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.FROB === '-1') {
        if (data.row.HaveToErp === '0') {
          return { 'background-color': '#FF6347', color: 'red' }
        } else if (data.row.Closed === '1' || data.row.Status === '3') {
          return { 'background-color': '#CCCCCC', color: 'red' }
        } else {
          return { color: 'red' }
        }
      } else {
        if (data.row.HaveToErp === '0') {
          return { 'background-color': '#FF6347' }
        } else if (data.row.Closed === '1' || data.row.Status === '3') {
          return { 'background-color': '#CCCCCC' }
        } else {
          return {}
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 生产入库单弹出框显示方法
    showICMOInStockDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      if (that.$refs.icmoSelectTable) {
        that.$refs.icmoSelectTable.clearSelected()
      }
      if (that.$refs.icmoInRequestSelectTable) {
        that.$refs.icmoInRequestSelectTable.clearSelected()
      }
      that.sourceEntrys = []
      that.showICMOInStockDialog = true
    },

    // 获取生产入库扫描标签表格高度
    getScanQRCodesTableHeight: function () {
      return window.innerHeight - 280 + 'px'
    },

    // 源单类型改变事件方法
    sourceTranTypeChange: function () {
    },

    // 源单单号改变事件方法
    sourceInterIDChange: function (row) {
      const that = this
      if (that.sourceTranType === 'WMS12') {
        if (that.sourceInterID) {
          for (let i = 0; i < row.detailDt1.length; i++) {
            row.detailDt1[i].ScanQty = 0
            row.detailDt1[i].ScanPackageQty = 0
          }
          that.sourceEntrys = row.detailDt1
        } else {
          that.sourceEntrys = []
        }
      }
    },

    // 显示条码明细表格特征字符串转换方法
    showQRCodesTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'Status') {
        return table.specialStringDisplayTransform(val, that.qrcodeStatuss)
      }
    },

    // 发料仓库选择方法
    dcstockChange: function () {
      const that = this
      if (that.$refs.icstockBillInfoDCSPIDTableSelect) {
        that.$refs.icstockBillInfoDCSPIDTableSelect.clearSelected()
      }
      for (let i = 0; i < that.stocks.length; i++) {
        if (that.stocks[i].StockID === that.icstockBillInfo.DCStockID) {
          that.dcstockTeam = that.stocks[i].SPGroupID
          break
        }
      }
    },

    // 扫码方法
    scanQRCodeEnterMD: async function () {
      const that = this
      if (that.sourceTranType === 'WMS12' && !that.sourceInterID) {
        that.$message.error('请先选择源单！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        if (that.sourceTranType === '85') {
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '0') {
              continue
            } else if (that.sourceInterID && that.sourceInterID !== qrCodeObj.tableContent[i].ICMOInterID) {
              loadingInstance.close()
              that.$message.error('该标签号不是通过该生产任务单直接或间接生成的，请扫描该生产任务单直接或间接生成的标签号！')
              that.scanQRCode = ''
              return
            } else if (qrCodeObj.tableContent[i].InitType !== '2') {
              loadingInstance.close()
              that.$message.error('该标签号不是产品标签号！')
              that.scanQRCode = ''
              return
            } else {
              let haveScanFlag = false
              for (let j = 0; j < that.scanQRCodes.length; j++) {
                if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                  haveScanFlag = true
                }
              }
              if (haveScanFlag) {
                qrCodeObj.tableContent[i].haveScanFlag = true
              }
            }
          }
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '0') {
              continue
            }
            if (qrCodeObj.tableContent[i].haveScanFlag) {
              addNum++
              continue
            }
            that.scanQRCodes.push(qrCodeObj.tableContent[i])
            addNum++
          }
          that.scanQRCode = ''
          if (addNum <= 0) {
            loadingInstance.close()
            that.$message.error('该外箱标签号中的没有可以直接入库的内箱标签！')
            return
          }
          if (!that.sourceInterID) {
            for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
              if (qrCodeObj.tableContent[i].Status !== '0') {
                continue
              }
              that.$refs.icmoSelectTable.setSelected(qrCodeObj.tableContent[i].ICMOInterID, qrCodeObj.tableContent[0].ICMOBillNo)
              break
            }
          }
        } else if (that.sourceTranType === 'WMS12') {
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '0') {
              continue
            } else if (qrCodeObj.tableContent[i].InitType !== '2') {
              loadingInstance.close()
              that.$message.error('该标签号不是产品标签号！')
              that.scanQRCode = ''
              return
            } else {
              let haveScanFlag = false
              for (let j = 0; j < that.scanQRCodes.length; j++) {
                if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                  haveScanFlag = true
                  break
                }
              }
              if (haveScanFlag) {
                qrCodeObj.tableContent[i].haveScanFlag = true
              }
              let haveICMOFlag = false
              let entryID = -1
              for (let j = 0; j < that.sourceEntrys.length; j++) {
                if (qrCodeObj.tableContent[i].ICMOInterID === that.sourceEntrys[j].ICMOInterID) {
                  haveICMOFlag = true
                  entryID = that.sourceEntrys[j].EntryID
                  break
                }
              }
              if (haveICMOFlag) {
                qrCodeObj.tableContent[i].EntryID = entryID
              } else {
                loadingInstance.close()
                that.$message.error('该标签号是通过该生产任务单【' + qrCodeObj.tableContent[i].ICMOBillNo + '】直接或间接生成的，该入库申请单中没有该生产任务单的入库申请！')
                that.scanQRCode = ''
                return
              }
            }
          }
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '0') {
              continue
            }
            if (qrCodeObj.tableContent[i].haveScanFlag) {
              addNum++
              continue
            }
            that.scanQRCodes.push(qrCodeObj.tableContent[i])
            addNum++
          }
          that.scanQRCode = ''
          if (addNum <= 0) {
            loadingInstance.close()
            that.$message.error('该外箱标签号中的没有可以直接入库的内箱标签！')
            return
          }
          that.scanQtyComputer()
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 删除已扫描
    deleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      if (that.scanQRCodes.length === 0) {
        if (that.$refs.icmoSelectTable) {
          that.$refs.icmoSelectTable.clearSelected()
        }
      }
      that.scanQtyComputer()
    },

    // 源单表格单元格样式
    sourceEntrysTableCellStyle: function ({ row, column, rowIndex, columnIndex }) {
      if (row.ScanQty < row.CanInQty) {
        return { padding: '0px' }
      } else if (row.ScanQty === row.CanInQty) {
        return { padding: '0px', 'background-color': '#cccccc' }
      } else if (row.ScanQty > row.CanInQty) {
        return { padding: '0px', 'background-color': '#FF4500' }
      }
      return { padding: '0px' }
    },

    // 已扫数量计算
    scanQtyComputer: function () {
      const that = this
      if (that.sourceTranType === 'WMS12') {
        for (let i = 0; i < that.sourceEntrys.length; i++) {
          that.sourceEntrys[i].ScanQty = 0
          that.sourceEntrys[i].ScanPackageQty = 0
        }
        for (let i = 0; i < that.scanQRCodes.length; i++) {
          for (let j = 0; j < that.sourceEntrys.length; j++) {
            if (that.sourceEntrys[j].EntryID === that.scanQRCodes[i].EntryID) {
              that.sourceEntrys[j].ScanQty += that.scanQRCodes[i].Qty
              that.sourceEntrys[j].ScanPackageQty++
              break
            }
          }
        }
        if (that.$refs.sourceEntrysTable) {
          that.$refs.sourceEntrysTable.doLayout()
        }
      }
    },

    // 产品入库
    icmoInStock: async function () {
      const that = this
      if (!that.sourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (!that.sourceInterID) {
        that.$message.error('请选择源单！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码')
        return
      }
      if (!that.icstockBillInfo.DCStockID) {
        that.$message.error('请选择收料仓库！')
        return
      }
      if (!that.icstockBillInfo.DCSPID) {
        that.$message.error('请选择收料仓位！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.PMInStock.ScanICMOInStock', {
        sourceTranType: that.sourceTranType,
        sourceInterID: that.sourceInterID,
        scanQRCodes: that.scanQRCodes,
        icstockBillInfo: that.icstockBillInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOInStockDialog = false
        if (rtnObj.msg) {
          that.$message.warning('入库成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('入库成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 重新上传产品入库单至金蝶
    uploadICMOICStockBill: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/UploadToERP.UploadICStockBill.UploadICStockBill2', {
        billNo: scope.data.row.BillNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('重新上传成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除产品入库单
    deletedICMOICStockBill: async function (scope) {
      const that = this
      that.$confirm('确定要删除该产品入库单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.PMInStock.DeleteScanICMOInStock', {
          billNo: scope.data.row.BillNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 产品入库单明细显示方法
    showICStockBillEntryDialogMD: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const icStockBillEntryObj = await table.getTableContent('WMS_ICStockBillEntry_PM'
        , 10000, 1, ' EntryID ASC', " AND BillNo='" + scope.data.row.BillNo + "'")
      if (icStockBillEntryObj.error === '000000') {
        that.icStockBillEntry = icStockBillEntryObj.tableContent
        that.icStockBill = scope.data.row
        that.showICStockBillEntryDialog = true
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 生产退库单弹出框显示方法
    showICMOOutStockDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      that.showICMOOutStockDialog = true
    },

    // 退库扫码方法
    outScanQRCodeEnterMD: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        if (that.outSourceTranType === '85') {
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '1') {
              continue
            } else if (that.outSourceInterID && that.outSourceInterID !== qrCodeObj.tableContent[i].ICMOInterID) {
              loadingInstance.close()
              that.$message.error('该标签号不是通过该生产任务单直接或间接生成的，一次只能退同一个工单的标签号！')
              that.scanQRCode = ''
              return
            } else if (qrCodeObj.tableContent[i].InitType !== '2') {
              loadingInstance.close()
              that.$message.error('该标签号不是产品标签号！')
              that.scanQRCode = ''
              return
            } else {
              let haveScanFlag = false
              for (let j = 0; j < that.scanQRCodes.length; j++) {
                if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                  haveScanFlag = true
                }
              }
              if (haveScanFlag) {
                qrCodeObj.tableContent[i].haveScanFlag = true
              }
            }
          }
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '1') {
              continue
            }
            if (qrCodeObj.tableContent[i].haveScanFlag) {
              addNum++
              continue
            }
            that.scanQRCodes.push(qrCodeObj.tableContent[i])
            addNum++
          }
          that.scanQRCode = ''
          if (addNum <= 0) {
            loadingInstance.close()
            that.$message.error('该外箱标签号中的没有可以直接退库的内箱标签！')
            return
          }
          if (!that.outSourceInterID) {
            for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
              if (qrCodeObj.tableContent[i].Status !== '1') {
                continue
              }
              that.outSourceInterID = qrCodeObj.tableContent[i].ICMOInterID
              break
            }
          }
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 退库删除已扫描
    outDeleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      if (that.scanQRCodes.length === 0) {
        that.outSourceInterID = ''
      }
    },

    // 获取生产入库扫描标签表格高度
    getOutScanQRCodesTableHeight: function () {
      return window.innerHeight - 210 + 'px'
    },

    // 产品退库
    icmoOutStock: async function () {
      const that = this
      if (!that.outSourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码')
        return
      }
      if (!that.outSourceInterID) {
        that.$message.error('请选择源单！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.PMInStock.ScanICMOOutStock', {
        outSourceTranType: that.outSourceTranType,
        outSourceInterID: that.outSourceInterID,
        scanQRCodes: that.scanQRCodes,
        outICStockBillInfo: that.outICStockBillInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOOutStockDialog = false
        if (rtnObj.msg) {
          that.$message.warning('退库成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('退库成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 重新上传产品退库单至金蝶
    uploadICMOOutICStockBill: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/UploadToERP.UploadICStockBill.UploadICStockBill2', {
        billNo: scope.data.row.BillNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('重新上传成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除产品退库单
    deletedICMOOutICStockBill: async function (scope) {
      const that = this
      that.$confirm('确定要删除该产品入库单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.PMInStock.DeleteScanICMOOutStock', {
          billNo: scope.data.row.BillNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 入库先进先出忽略
    fiNotSet: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      that.$confirm('确定要忽略该入库单的入库先进先出卡控吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.FINotSet', {
          rows: that.mainTable.selections
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('忽略成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
